import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, throwError, from } from 'rxjs';
import { catchError, tap,timeout } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ServiceMockService {

  constructor(private httpClient:HttpClient) { }

  getData(): Promise<any> {
    const promise = new Promise ((resolve,reject)=>{
        return this.httpClient.get('../../assets/data/facturaciones.mock.json')
        	 .toPromise().then(
             data => {resolve(data);},
             error=> {reject(error);})
            .catch(err => {Promise.reject(err.error || 'Server error');});
      });
      return promise;
  }
}
